import React from 'react';
import { Home } from 'lucide-react';

const Logo = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-br from-[#8B1538] to-[#A0252C] rounded-lg blur-sm opacity-50"></div>
        <div className="relative bg-gradient-to-br from-[#8B1538] to-[#A0252C] p-2 rounded-lg shadow-lg">
          <Home className="w-6 h-6 text-white" strokeWidth={2.5} />
        </div>
      </div>
      <div className="flex flex-col leading-tight">
        <span className="text-xl font-bold text-[#8B1538]">St. Croix</span>
        <span className="text-sm font-semibold text-[#A0252C] -mt-1">Appraisals</span>
      </div>
    </div>
  );
};

export default Logo;